/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum PaymentType {
    Zahlschein = 'Zahlschein',
    Sepa = 'Sepa',
    Unentgeltlich = 'Unentgeltlich'
  }

    export const PaymentTypeTranslocoMap: Record<PaymentType, string> = {
    [PaymentType.Zahlschein]: 'paymentType.zahlschein',
    [PaymentType.Sepa]: 'paymentType.sepa',
    [PaymentType.Unentgeltlich]: 'paymentType.unentgeltlich',
    };

    export const PaymentTypeOptions = [
  { value: PaymentType.Zahlschein, labelKey: 'paymentType.zahlschein' },
  { value: PaymentType.Sepa, labelKey: 'paymentType.sepa' },
  { value: PaymentType.Unentgeltlich, labelKey: 'paymentType.unentgeltlich' },
    ];

